import { TableCell, TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useCallback, useEffect, useState } from "react";
import NumberFormatCustom from "./NumberFormatCustom";
import PropTypes from "prop-types";
import { Autocomplete } from "@mui/material";
import LongTextPopUp from "../LongTextPopUp";

const inputMargin = 5;
const useStyles = makeStyles((theme) => ({
  editCell: {
    padding: 0,
  },
}));

const TextCell = (props) => {
  const classes = useStyles();
  const { label, value, width, ...rest } = props;
  return (
    <TableCell className={classes.editCell}>
      <TextField
        defaultValue={value}
        size="small"
        {...rest}
        style={{ margin: inputMargin }}
      ></TextField>
    </TableCell>
  );
};

const NumberCell = (props) => {
  const classes = useStyles();
  const { label, value, limit,onChange, ...rest } = props;
  return (
    <TableCell className={classes.editCell}>
      <TextField
        style={{ margin: inputMargin }}
        size="small"
        value={value}
        InputProps={{
          inputComponent: NumberFormatCustom,
          inputProps: { limit: limit },
        }}
        onChange={onChange}
        {...rest}
      ></TextField>
    </TableCell>
  );
};

const OptionsCell = (props) => {
  const classes = useStyles();
  const {
    label,
    name,
    options,
    variant,
    onChange,
    value,
    error,
    helperText,
    required,
    disabled,
  } = props;

  const [inputValue, setInputValue] = useState(null);
  const handleChange = useCallback(
    (data) => {
      setInputValue(data || null);
      onChange({ target: { name, value: data?.id || "" } });
    },
    [name, onChange]
  );

  useEffect(() => {
    if (!value) {
      handleChange(null);
      return;
    }
    const option = options.find((o) => o.id === value);
    handleChange(option);
  }, [handleChange, options, value]);

  return (
    <TableCell className={classes.editCell}>
      <Autocomplete
        value={inputValue || null}
        disabled={disabled}
        options={options}
        onChange={(_e, data) => handleChange(data)}
        getOptionLabel={(option) => option?.label || ""}
        size="small"
        style={{ margin: inputMargin }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant={variant}
            error={error}
            helperText={helperText}
            required={required}
          />
        )}
      />
    </TableCell>
  );
};

const DateCell = (props) => {
  const classes = useStyles();
  const { label, value, width, ...rest } = props;

  return (
    <TableCell className={classes.editCell}>
      <TextField
        defaultValue={value.slice(0, value.indexOf("T"))}
        size="small"
        type="date"
        {...rest}
        style={{ margin: inputMargin }}
      ></TextField>
    </TableCell>
  );
};

const LongTextCell = (props) => {
  const classes = useStyles();
  const { label, value, width, setValue, ...rest } = props;
  const [shortValue, setShortValue] = useState(value);
  const [open, setOpen] = useState(false);

  const onSave = (value) => {
    setOpen(!open);
    setShortValue(value);
    setValue(value);
  };
  return (
    <TableCell className={classes.editCell}>
      <TextField
        value={shortValue}
        size="small"
        {...rest}
        style={{ margin: inputMargin }}
        onClick={() => setOpen(!open)}
      ></TextField>
      <LongTextPopUp
        editable
        value={value}
        open={open}
        setOpen={setOpen}
        onSave={onSave}
      />
    </TableCell>
  );
};

// NumberCell.propTypes = {
//   name: PropTypes.string.isRequired,
//   onChange: PropTypes.func.isRequired,
// };

export default function EditableCell(props) {
  const { config, value, onChange, ...rest } = props;
  const classes = useStyles();

  const [currentValue, setCurrentValue] = useState(
    value !== undefined && value !== null ? value : ""
  );

  const handleBlur = (e) => {
    setCurrentValue(e.target.value);
    const customEvent = { target: { name: props.name, value: e.target.value } };
    onChange(customEvent);
  };

  const handleChange = (e) => {
    setCurrentValue(e.target.value);
  };

  if (typeof config.calculation === "function")
    return <TableCell className={classes.editCell}></TableCell>;
  switch (config.type) {
    case "number":
      return (
        <NumberCell
          variant="outlined"
          size="small"
          value={currentValue}
          limit={config.limit}
          onChange={handleChange}
          onBlur={handleBlur}
          {...rest}
        />
      );
    case "options":
      return (
        <OptionsCell
          variant="outlined"
          size="small"
          options={config.options}
          disabled={config.disabled}
          value={currentValue}
          onChange={handleBlur}
          {...rest}
        />
      );
    case "longText":
      return (
        <LongTextCell
          variant="outlined"
          size="small"
          value={currentValue}
          setValue={setCurrentValue}
          onBlur={handleBlur}
          {...rest}
        />
      );
    case "date":
      return (
        <DateCell
          variant="outlined"
          size="small"
          value={currentValue}
          onChange={handleChange}
          onBlur={handleBlur}
          {...rest}
        />
      );
    default:
      return (
        <TextCell
          variant="outlined"
          size="small"
          value={currentValue}
          onChange={handleChange}
          onBlur={handleBlur}
          inputProps={
            config.capitalize && { style: { textTransform: "capitalize" } }
          }
          {...rest}
        />
      );
  }
}

EditableCell.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
